import { ReactNode, useRef } from "react"
import {
  Animated,
  GestureResponderEvent,
  Pressable,
  PressableProps,
  StyleProp,
  ViewStyle,
} from "react-native"

const AnimatedPressable = Animated.createAnimatedComponent(Pressable)

type PressableScaleProps = Omit<PressableProps, "children" | "style"> & {
  children: ReactNode
  className?: string
  style?: StyleProp<ViewStyle>
  scaleTo?: number
}

export function PressableScale({
  children,
  className,
  style,
  scaleTo = 0.975,
  onPressIn,
  onPressOut,
  ...props
}: PressableScaleProps) {
  const scale = useRef(new Animated.Value(1)).current

  const animateTo = (value: number) => {
    Animated.spring(scale, {
      toValue: value,
      speed: 28,
      bounciness: 5,
      useNativeDriver: true,
    }).start()
  }

  const handlePressIn = (event: GestureResponderEvent) => {
    animateTo(scaleTo)
    onPressIn?.(event)
  }

  const handlePressOut = (event: GestureResponderEvent) => {
    animateTo(1)
    onPressOut?.(event)
  }

  return (
    <AnimatedPressable
      {...props}
      className={className}
      style={[style, { transform: [{ scale }] }]}
      onPressIn={handlePressIn}
      onPressOut={handlePressOut}
    >
      {children}
    </AnimatedPressable>
  )
}
